const C = {
  name: "Webinar",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 8C9 6.34772 10.3477 5 12 5C13.6523 5 15 6.34772 15 8C15 9.65228 13.6523 11 12 11C10.3477 11 9 9.65228 9 8ZM12 7C11.4523 7 11 7.45228 11 8C11 8.54772 11.4523 9 12 9C12.5477 9 13 8.54772 13 8C13 7.45228 12.5477 7 12 7Z" fill="currentColor"/>
<path d="M17.5 5.25C17.5 4.56 18.06 4 18.75 4C19.44 4 20 4.56 20 5.25C20 5.94 19.44 6.5 18.75 6.5C18.06 6.5 17.5 5.94 17.5 5.25Z" fill="currentColor"/>
<path d="M1 4C1 2.34772 2.34772 1 4 1H20C21.6523 1 23 2.34772 23 4V16C23 17.6523 21.6523 19 20 19H4C2.34772 19 1 17.6523 1 16V4ZM16 15C16 14.7409 15.8994 14.4936 15.7029 14.2971L15.6935 14.2877C15.5163 14.1057 15.2668 14 15 14H9C8.74089 14 8.49362 14.1006 8.29711 14.2971L8.28768 14.3065C8.10573 14.4837 8 14.7332 8 15V17H16V15ZM18 17H20C20.5477 17 21 16.5477 21 16V4C21 3.45228 20.5477 3 20 3H4C3.45228 3 3 3.45228 3 4V16C3 16.5477 3.45228 17 4 17H6V15C6 14.209 6.31259 13.4406 6.88758 12.8782C7.45055 12.3176 8.20133 12 9 12H15C15.791 12 16.5593 12.3126 17.1218 12.8876C17.6824 13.4505 18 14.2013 18 15V17Z" fill="currentColor"/>
<path d="M17 21V23H7V21H17Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Webinar
};
